import {
  DealStatusSelector,
  type DealStatusSelectorProps,
} from './deal-status-selector';

// DEV NOTE: this is just a wrapper around the DealStatusSelector component
// that is used to make the button look like a button
export function DealStatusSelectorButton({
  id,
  shortId,
  value,
  hideCopy = false,
  side = 'left',
  className,
}: DealStatusSelectorProps) {
  return (
    <DealStatusSelector
      id={id}
      shortId={shortId}
      value={value}
      hideCopy={hideCopy}
      side={side}
      buttonVariant={'outline'}
      className={className}
    />
  );
}
